export enum ScheduledReportsAction {
  ADD_REPORT = "addScheduledReport",
  EDIT_REPORT = "editScheduledReport",
  ADD_EXPORT = "addScheduledExport",
  EDIT_EXPORT = "editScheduledExport",
  DELETE = "deleteScheduledReport",
}
